import { inject, Injectable } from '@angular/core';
import { catchError, map, of, switchMap, withLatestFrom } from 'rxjs';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SurveyActions } from '../actions/survey.actions';
import { SurveyService } from '../../services/survey/survey.service';
import { Store } from '@ngrx/store';
import { selectSurveyRequest } from '../selectors/survey.selectors';
import { omitNullValues } from '@ps/utils';

@Injectable()
export class SurveyEffects {
  private readonly _store = inject(Store);
  private readonly _actions$ = inject(Actions);
  private readonly _surveyService = inject(SurveyService);

  public loadEntities$ = createEffect(() =>
    this._actions$.pipe(
      ofType(
        SurveyActions.init,
        SurveyActions.setFilters,
        SurveyActions.resetFilters,
        SurveyActions.setSort,
        SurveyActions.reload,
        SurveyActions.loadNextPage,
      ),
      withLatestFrom(
        this._store.select(selectSurveyRequest).pipe(map(omitNullValues)),
      ),
      switchMap(([, request]) =>
        this._surveyService.getSurveys(request).pipe(
          map((surveys) => SurveyActions.loadSuccess({ surveys })),
          catchError((error) =>
            of(SurveyActions.loadFailure({ error: error.message })),
          ),
        ),
      ),
    ),
  );
}
